import classNames from "classnames";
import type { RelationshipFieldset } from "@/entities/form-metadata";
import { useTrackSearchFormInteraction } from "@/shared/lib/ube";
import { useIsNewRelationshipEnabled } from "../useIsNewRelationshipEnabled";
import styles from "./AddNewFamilyMemberButton.module.scss";

interface AddNewFamilyMemberButtonProps {
    fieldset: RelationshipFieldset;
    onItemAdded: (fieldset: RelationshipFieldset) => void;
}

export const AddNewFamilyMemberButton = ({ fieldset, onItemAdded }: AddNewFamilyMemberButtonProps) => {
    const isDisabled = useIsNewRelationshipEnabled({ fieldset });
    const track = useTrackSearchFormInteraction();

    const handleClick = () => {
        track({ objectName: "add_family_member" });
        onItemAdded(fieldset);
    };

    return (
        <button
            type="button"
            className={classNames(styles.addRelation, "link headerLink")}
            disabled={isDisabled}
            onClick={handleClick}
            data-testid={`add-family-member-${fieldset.relation}`}
        >
            {fieldset.label}
        </button>
    );
};
